import React from 'react'
import { Entry } from 'contentful'

import { ICtaButtonMvp as IContentfulCtaButton } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import {
  CTAButton,
  IProps as ICtaButtonProps,
} from 'marketing-site/src/mvp/library/elements/CTAButton'
import { CTATheme } from '../../library/utils/constants/CTATheme'
import { getTypedCtaTheme } from '../../library/utils/constants/themes'

function handleCTAClick(e: React.MouseEvent) {
  e.preventDefault()
}

export function isCTAButton(entry: Entry<any>): entry is IContentfulCtaButton {
  return entry.sys.contentType?.sys.id === 'ctaButton'
}

export const ContentfulCTAButton = (ctaButton: IContentfulCtaButton): React.ReactElement => (
  <EntryMarker entry={ctaButton}>
    <CTAButton {...transformCTAButton(ctaButton)} />
  </EntryMarker>
)

export function transformCTAButton({ fields }: IContentfulCtaButton): ICtaButtonProps {
  return {
    ...fields,
    text: fields.text,
    variant: getTypedCtaTheme<CTATheme>(fields.variant),
    onClick: handleCTAClick,
  }
}
